import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useTenantContext } from '../contexts';
import PresTable from '../features/table/PresTable';
import { useVerificationService } from '../services';
import { useLocation, useNavigate } from 'react-router-dom';
import { mdiArrowLeft } from '@mdi/js';
import HeaderButton from '../components/layout/HeaderButton';
/**
 * PresentationPage component protected by AdminAuthGuard
 * Displays basic admin interface
 *
 * @return {JSX.Element}
 */
const PresentationPage: React.FC = () => {
  const navigate = useNavigate();
  const tenantContext = useTenantContext();
  const verificationService = useVerificationService();

  const { state } = useLocation();

  if (!state) {
    return (
      <View style={styles.container}>
        <Text>No users selected</Text>
      </View>
    );
  }
  const { users } = state;

  const parsedUsers = users ? JSON.parse(users) : [];

  const selectedUsers = tenantContext.users?.filter((user) => parsedUsers.includes(user.user_id));

  const handleSendVerificationRequest = async (email: string, verificationId: string) => {
    try {
      await verificationService.sendVerificationRequest(verificationId, email);
    } catch (error) {
      console.error('Error sending verification request:', error);
    }
  };
  const handleSendGroupVerificationRequest = async (
    connectionIds: string[],
    verificationId: string
  ) => {
    try {
      await verificationService.sendGroupVerificationRequest(verificationId, connectionIds);
    } catch (error) {
      console.error('Error sending group verification request:', error);
    }
  };

  const handleBack = () => {
    navigate('/');
  };

  return (
    <View style={styles.container}>
      <View style={[styles.headerRow, { gap: 8 }]}>
        <HeaderButton onPress={handleBack} icon={mdiArrowLeft} />
        <Text style={styles.header}>Admin Dashboard</Text>
      </View>
      <View style={styles.tablesContainer}>
        {tenantContext.users && (
          <View style={styles.tableSection}>
            <PresTable
              users={selectedUsers || []}
              verifications={tenantContext.verifications || []}
              onSendVerificationRequest={handleSendVerificationRequest}
              verificationRequests={tenantContext.verificationRequests}
              onSendGroupVerificationRequest={handleSendGroupVerificationRequest}
            />
          </View>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    maxWidth: 1600,
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%'
  },
  header: {
    fontSize: 24,
    fontWeight: '700',
    color: '#000000'
  },
  contentSection: {
    backgroundColor: '#ffffff',
    padding: 16,
    borderRadius: 8,
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    marginBottom: 16
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#30394C',
    marginBottom: 8
  },
  description: {
    fontSize: 14,
    color: '#6B7280',
    lineHeight: 20
  },
  tablesContainer: {
    flex: 1,
    flexDirection: 'row',
    gap: 16,
    minHeight: 600
  },
  tableSection: {
    backgroundColor: '#ffffff',
    borderRadius: 8,
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    flex: 1,
    overflow: 'hidden'
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    marginBottom: 16
  }
});

export default PresentationPage;
